import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { filter, firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-update-contact-info',
    templateUrl: './update-contact-info.component.html',
    styleUrls: ['./update-contact-info.component.scss'],
})
export class UpdateContactInfoComponent implements OnInit {
    subscriptions: Subscription = new Subscription();
    public ecosystem: string = this.profileService.getCurrentEcosystem();
    public b_ocultarcontacto: boolean;
    public b_ocultarredes: boolean;

    constructor(private profileService: ProfileService, private dialogRef: MatDialogRef<UpdateContactInfoComponent>) {}

    ngOnInit(): void {
        this.b_ocultarcontacto = this.profileService.b_ocultarcontacto;
        this.b_ocultarredes = this.profileService.b_ocultarredes;
        this.subscriptions.add(
            this.profileService.resetDataSubject.pipe(filter((x) => x.loadData)).subscribe(() => {
                this.b_ocultarcontacto = this.profileService.b_ocultarcontacto;
                this.b_ocultarredes = this.profileService.b_ocultarredes;
            })
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    saveVisibility() {
        let data = {
            artist: 0,
            ocultar_contacto: this.b_ocultarcontacto,
            ocultar_redes: this.b_ocultarredes,
        };
        firstValueFrom(this.profileService.patchOneUrl(data, this.ecosystem, `/${this.profileService.getEcosystemRoute(this.ecosystem)}/0`)).then((x) => {
            Swal.fire({
                title: 'Confirmación',
                text: 'Guardado correctamente',
                icon: 'success',
                confirmButtonColor: '#28a745',
                confirmButtonText: 'Aceptar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.dialogRef.close({
                        b_ocultarcontacto: this.b_ocultarcontacto,
                        b_ocultarredes: this.b_ocultarredes,
                    });
                }
            });
        });
    }

    closeModal() {
        this.dialogRef.close();
    }
}
